// @flow
import * as ActionTypes from "constants/ActionTypes";

const initialState = {
  serviceError: "",
  serviceCode: 200,
  reqStatus: "",
  isLoading: false,
  bootupCompleted: false,
  userDetails: {
    photo: "https://randomuser.me/api/portraits/men/11.jpg",
    name: "",
    phone: "",
    email: "",
  },
  billingAddress: null,
  usersAddress: {},
  tryonProfileImage: null,
  tryonProfileImages: [],
  virtualTryOnResult: null,
  tryonCredits: null,
};

export default function(state: Object = initialState, action: Object) {
  switch (action.type) {
      /* Common Triggers */
    case ActionTypes.USER_LOGIN_START:
    case ActionTypes.USER_REGISTER_START:
    case ActionTypes.USER_RESET_PASSWORD_START:
    case ActionTypes.USER_GET_USER_PROFILE_START:
    case ActionTypes.USER_UPDATE_USER_PROFILE_START:
    case ActionTypes.USER_GET_BILLING_ADDRESS_START:
    case ActionTypes.USER_UPDATE_BILLING_ADDRESS_START:
    case ActionTypes.USER_GET_USER_LOCATION_START:
    case ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_START:
    case ActionTypes.GET_TRYON_PROFILE_IMAGE_START:
    case ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_START:
    case ActionTypes.DELETE_TRYON_PROFILE_IMAGE_START:
    case ActionTypes.GENERATE_VIRTUAL_TRYON_START:
    case ActionTypes.GET_TRYON_CREDITS_START:
    case ActionTypes.GET_TRYON_HISTORY_START:
    case ActionTypes.GET_TRYON_DETAILS_START:
    case ActionTypes.DELETE_TRYON_START: {
      return {
        ...state,
        isLoading: true,
        reqStatus: action.type,
        serviceError: "",
      };
    }

      /* Common Failures */
    case ActionTypes.USER_LOGIN_FAILURE:
    case ActionTypes.USER_REGISTER_FAILURE:
    case ActionTypes.USER_RESET_PASSWORD_FAILURE:
    case ActionTypes.USER_GET_USER_PROFILE_FAILURE:
    case ActionTypes.USER_UPDATE_USER_PROFILE_FAILURE:
    case ActionTypes.USER_GET_BILLING_ADDRESS_FAILURE:
    case ActionTypes.USER_UPDATE_BILLING_ADDRESS_FAILURE:
    case ActionTypes.USER_GET_USER_LOCATION_FAILURE:
    case ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_FAILURE:
    case ActionTypes.GET_TRYON_PROFILE_IMAGE_FAILURE:
    case ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_FAILURE:
    case ActionTypes.DELETE_TRYON_PROFILE_IMAGE_FAILURE:
    case ActionTypes.GENERATE_VIRTUAL_TRYON_FAILURE:
    case ActionTypes.GET_TRYON_CREDITS_FAILURE:
    case ActionTypes.GET_TRYON_HISTORY_FAILURE:
    case ActionTypes.GET_TRYON_DETAILS_FAILURE:
    case ActionTypes.DELETE_TRYON_FAILURE: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        //bootupCompleted: false,
        serviceError: "",
      };
    }

      /* Success Handlers */
    case ActionTypes.USER_LOGIN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        bootupCompleted: true,
        userDetails: {...state.userDetails, ...action.payload},
      };
    }

    case ActionTypes.USER_LOGOUT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        bootupCompleted: false,
        userDetails: {...initialState.userDetails},
      };
    }

    case ActionTypes.USER_REGISTER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        bootupCompleted: true,
        userDetails: action.payload,
      };
    }

    case ActionTypes.USER_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        bootupCompleted: true,
        userDetails: action.payload,
      };
    }

    case ActionTypes.USER_GET_USER_PROFILE_SUCCESS:
    case ActionTypes.USER_UPDATE_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        bootupCompleted: true,
        userDetails: {...state.userDetails, ...action.payload},
      };
    }

    case ActionTypes.USER_GET_BILLING_ADDRESS_SUCCESS:
    case ActionTypes.USER_UPDATE_BILLING_ADDRESS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        bootupCompleted: true,
        billingAddress: action.payload,
      };
    }

    case ActionTypes.USER_GET_USER_LOCATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        userAddress: action.payload,
      };
    }

      /* Virtual Try-On Profile Image Success Handlers */
    case ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          tryonProfileImage: action.payload?.profile_image || null,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          tryonProfileImage: null,
        };
      }
    }

    case ActionTypes.GET_TRYON_PROFILE_IMAGE_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          tryonProfileImage: action.payload?.response?.profile_image || null,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          tryonProfileImage: null,
        };
      }
    }

    case ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_SUCCESS: {
        if (action.payload.statusCode === 200) {
          return {
            ...state,
            isLoading: false,
            reqStatus: action.type,
            serviceError: "",
            tryonProfileImages: action.payload?.response?.profile_images || [],
          };
        } else {
          return {
            ...state,
            isLoading: false,
            reqStatus: action.type,
            serviceError: action.payload?.statusMessage,
            serviceCode: action.payload?.statusCode,
            tryonProfileImages: [],
          };
        }
      }

    case ActionTypes.DELETE_TRYON_PROFILE_IMAGE_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          tryonProfileImage: null,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          tryonProfileImage: null,
        };
      }
    }

    /* Virtual Try-On Generation Success Handlers */
    case ActionTypes.GENERATE_VIRTUAL_TRYON_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          virtualTryOnResult: action.payload?.response,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          virtualTryOnResult: null
        };
      }
    }

    case ActionTypes.GET_TRYON_CREDITS_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          tryonCredits: action.payload?.response,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          tryonCredits: null,
        };
      }
    }

    case ActionTypes.GET_TRYON_HISTORY_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          tryonHistory: action.payload?.response,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          tryonHistory: action.payload?.response,
        };
      }
    }
    case ActionTypes.GET_TRYON_DETAILS_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          currentTryOn: action.payload,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          currentTryOn: action.payload?.response,
        };
      }
    }

    case ActionTypes.DELETE_TRYON_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          tryonHistory: state.tryonHistory ? {
            ...state.tryonHistory,
            history: state.tryonHistory.history.filter(
                tryon => tryon._id !== action.payload?.response?.tryonId
            )
          } : state.tryonHistory,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload?.statusMessage,
          serviceCode: action.payload?.statusCode,
          // tryonHistory is in state
        };
      }
    }

    default:
      return state;
  }
}
